"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./GeneralHeroSec.scss");

var _GeneralLozenge = _interopRequireDefault(require("../GeneralLozenge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GeneralHeroSec = function GeneralHeroSec(props) {
  var _props$data = props.data,
      className = _props$data.className,
      headerText = _props$data.headerText,
      activeLozenge = _props$data.activeLozenge,
      lozengeText = _props$data.lozengeText,
      mainImg = _props$data.mainImg,
      iconImg = _props$data.iconImg,
      headerPrefix = _props$data.headerPrefix,
      displayIcon = _props$data.displayIcon;
  return _react.default.createElement("section", {
    className: "generalHero"
  }, _react.default.createElement("img", {
    className: "generalHeroImgFit",
    src: mainImg.url,
    alt: "general image"
  }), displayIcon ? _react.default.createElement("img", {
    className: className,
    src: iconImg.url,
    alt: "general Icon"
  }) : "", _react.default.createElement("h1", {
    className: "generalTextH1"
  }, _react.default.createElement("span", null, headerPrefix), " ", headerText), activeLozenge ? _react.default.createElement(_GeneralLozenge.default, {
    LozengeText: lozengeText
  }) : null);
};

GeneralHeroSec.defaultProps = {
  className: "",
  headerText: "",
  activeLozenge: false,
  lozengeText: "",
  mainImg: "",
  displayIcon: false,
  iconImg: "",
  headerPrefix: ""
};
var _default = GeneralHeroSec;
exports.default = _default;